export default "__VITE_ASSET__DemRI7uf__"